import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  standalone: false
})
export class HomeComponent {
  mobileMenuOpen = false;

  plans = [
    {
      id: 'plano-50',
      name: 'Plano 50',
      capacity: 'Até 50 usuários',
      price: 'R$ 99,90',
      featured: false,
      features: ['Comunicados', 'Tarefas agendadas', 'Gestão de incidentes']
    },
    {
      id: 'plano-150',
      name: 'Plano 150',
      capacity: 'Até 150 usuários',
      price: 'R$ 279,90',
      featured: true,
      features: ['Comunicados', 'Tarefas agendadas', 'Gestão de incidentes']
    },
    {
      id: 'plano-150-plus',
      name: 'Plano 150+',
      capacity: 'Usuários ilimitados',
      price: 'R$ 589,90',
      featured: false,
      features: ['Comunicados', 'Tarefas agendadas', 'Gestão de incidentes']
    }
  ];

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  goToSignup(): void {
    this.mobileMenuOpen = false;
    this.router.navigate(['/signup']);
  }

  onLogin(): void {
    this.mobileMenuOpen = false;
    this.authService.initiateLogin();
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  scrollTo(sectionId: string): void {
    this.mobileMenuOpen = false;
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
